import { createSlice } from "@reduxjs/toolkit";
const memberReportSlice = createSlice({
  name: "memberReport",

  //initial state
  initialState: {
    report: {},
    addressLabelData: {},
  },

  //reducer
  reducers: {
    setMemberReportDetails: (state, action) => {
      state.report = action.payload;
    },
    setAddressLabelData: (state, action) => {
      state.addressLabelData = action.payload;
    },
  },
});

export default memberReportSlice.reducer;
export const { setMemberReportDetails, setAddressLabelData } =
  memberReportSlice.actions;
export const selectCurrentMemberReport = (state) => state.memberReport.report;
export const selectCurrentAddressLabelData = (state) =>
  state.memberReport.addressLabelData;
